<template>
  <narrow-container>
    <div
      id="loading"
      :class="{'show':inProgress}"
    />
    <h1 class="headline-secondary text--center">
      {{ this.$i18n.t('PASSWORD_CHANGE.HEADER') }}
    </h1>
    <p>
      {{ this.$i18n.t('PASSWORD_CHANGE.INFO') }}
    </p>
    <input-box
      id="passwordField"
      ref="passwordField"
      :label="this.$i18n.t('PASSWORD_CHANGE.OLD_PASSWORD')"
      name="passwordField"
      type="password"
    />
    <selfcare-password-input
      id="newPasswordField"
      ref="newPasswordField"
      name="newPasswordField"
      :label1="this.$i18n.t('PASSWORD_CHANGE.NEW_PASSWORD')"
      :label2="this.$i18n.t('PASSWORD_CHANGE.CONFIRM_PASSWORD')"
      :mandatory="true"
    />
    <submit-button
      id="passwordChangeSubmitButton"
      :label="this.$i18n.t('PASSWORD_CHANGE.SUBMIT')"
      :on-click="submitForm"
    />
  </narrow-container>
</template>

<script>
import Regex from '@/constants/regex.json';

const RESP_VALIDATION_ERROR = 1;
const RESP_MSISDN_NOT_PREPAID = 2;
const RESP_PASSWORD_INCORRECT = 3;
const RESP_TEMPORARILY_LOCKED = 4;
const RESP_LOCKED = 5;
const RESP_OTHER_ERROR = 9999;

export default {
  name: 'KuzoRegistration',
  components: { },
  data: function() {
    return {
      inProgress: false,
      passwordsMatch: true,
      isMounted: false,
    };
  },
  computed: {
  },
  mounted: function(){
    this.isMounted = true;
  },
  methods: {
    isNewDifferent: function() {
      this.newDifferent = (this.$refs.newPasswordField.getFieldValue()
        != this.$refs.passwordField.getFieldValue());
      if (!this.newDifferent) {
        this.$store.commit("setErrorMessage", this.$i18n.t('PASSWORD_CHANGE.OLD_SAME_AS_NEW'));
      }
      return this.newDifferent;
    },
    isFormValid: function() {
      const isValid = this.$refs.newPasswordField.isValidBeforeSubmit()
        && this.isNewDifferent();
      return isValid;
    },
    submitForm: function() {
      if (!this.inProgress && this.isFormValid()) {
        this.inProgress = true;
        const changePasswordRequest = {
          oldPassword: this.$refs.passwordField.getFieldValue(),
          newPassword: this.$refs.newPasswordField.getFieldValue(),
        };
        this.$http.post('api/user/password', changePasswordRequest)
          .then(() => {
            this.processSuccessfulCallResponse();
          })
          .catch(callData => {
            this.processErrorCallResponse(callData);
          })
          .finally( () => {
            this.inProgress = false;
          })
      }
    },
    processSuccessfulCallResponse: function(response) {
        this.$store.commit("setSuccessMessage", this.$i18n.t('PASSWORD_CHANGE.SUCCESS'));
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password change',label: 'Success', value: 0, noninteraction: false });
        this.$router.push({name: 'profile'});
    },

    processErrorCallResponse: function(callData) {
      if(callData.response === undefined || callData.response.data === undefined) {
        this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password change',label: 'Error - no data', value: 0, noninteraction: false });
        return;
      }

      let responseCode = callData.response.data.responseCode;

      switch(responseCode) {
        case RESP_VALIDATION_ERROR:
          this.$refs.newPasswordField.setValidationErrorAndScroll($i18n.t('COMMON.ERROR_MESSAGES.PASSWORD_ERROR'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password change',label: 'Error - validation', value: 0, noninteraction: false });
          break;
        case RESP_MSISDN_NOT_PREPAID:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.MSISDN_NOT_ACTIVE_PREPAID'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password change',label: 'Error - MSISDN not active prepaid', value: 0, noninteraction: false });
          break;
        case RESP_PASSWORD_INCORRECT:
          this.$store.commit("setErrorMessage", this.$i18n.t('PASSWORD_CHANGE.ERROR_MESSAGES.OLD_PASSWORD_NOT_CORRECT'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password change',label: 'Error - old password incorrect', value: 0, noninteraction: false });
          break;
        case RESP_LOCKED:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.LOGIN_LOCKED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password change',label: 'Error - locked', value: 0, noninteraction: false });
          break;
        case RESP_TEMPORARILY_LOCKED:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.LOGIN_TEMPORARILY_LOCKED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password change',label: 'Error - temporarily locked', value: 0, noninteraction: false });
          break;
        case RESP_OTHER_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password change',label: 'Error - technical issue', value: 0, noninteraction: false });
          break;
        default:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password change',label: 'Error - '+responseCode, value: 0, noninteraction: false });
        }
    },
  },
};
</script>

<style lang="scss" src="@/components/loading/loading.scss">
</style>
